import React, { HTMLAttributes } from 'react';
import { identifyComponent } from '../../util';

interface GridItemProps extends HTMLAttributes<HTMLDivElement> {
  testId?: string;
  width: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  height: number;
}

interface GridItemStyles {
  gridColumn: string;
  gridRow: string;
}

const getGridItemStyles = ({ height, width }: GridItemProps): GridItemStyles => ({
  gridColumn: `span ${width}`,
  gridRow: `span ${height}`,
});

export const GridItem: React.FC<GridItemProps> = function GridItem(props) {
  const { width, height, testId = 'grid-item', ...rest } = props;
  const gridItemStyles = getGridItemStyles(props);
  return (
    <div
      data-component="GridItem"
      {...rest}
      {...identifyComponent('grid-item', rest)}
      style={{ ...gridItemStyles, ...rest.style }}
      data-testid={testId}
    />
  );
};
